import { AxiosError } from 'axios';
import { authHeader } from 'services';
import { formatISO, subDays, } from 'date-fns';
import { Api } from './api/axios.service';

const getReport = async ({page, limit, startdate, enddate, planid}: any): Promise<any> => {
  const _page = page ? page : 1;
  const _limit = limit ? limit : 10;
  const _startdate = startdate ? startdate : formatISO(subDays(new Date(), 20));
  const _enddate = enddate ? enddate : formatISO(new Date());
  const _planid = planid ?? null;
  try {
    const { data } = await Api.get<any>(`/report/findAll/${_page}/${_limit}`, {
      headers: planid ? {...authHeader(), startdate: _startdate, enddate: _enddate, planid: _planid} : {...authHeader(), startdate: _startdate, enddate: _enddate},
    });

    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};
const downloadReport = async (startdate: any, enddate: any, planid: any): Promise<any> => {
  const _startdate = startdate ? startdate : formatISO(subDays(new Date(), 20));
  const _enddate = enddate ? enddate : formatISO(new Date());
  const _planid = planid ?? null;
  try {
    const { data } = await Api.get<any>(`/report/download`, {
      responseType: 'blob',
      headers: planid ? {...authHeader(), startdate: _startdate, enddate: _enddate, planid: _planid} : {...authHeader(), startdate: _startdate, enddate: _enddate},
    });
    
    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;
    throw new Error(
      response?.data?.error || 'Não foi possível listar o relatório'
    );
  }
};

export const AdminReportService = {
  getReport,
  downloadReport
};

